module.exports = __webpack_public_path__ + "img/logo.8e9e4131.png";